import { useMappedState } from "redux-react-hook";
import * as React from "react";

import type { IStore } from "src/core/shared/store";
import type { IUser } from "src/core/users/api/users.api";
import type { IRole } from "src/core/shared/api/roles.api";

interface IState {
  currentUser: IUser | null;
  currentRole: IRole | null;
}

const useCurrentUser = (): [IState] => {
  const { currentUser, currentRole } = useMappedState(({ global }: IStore) => ({
    currentUser: global.user,
    currentRole: global.role
  }));

  return React.useMemo(() => ([
    {
      currentUser,
      currentRole
    }
  ]), [ currentUser, currentRole ]);
};

export default useCurrentUser;
